{
  "id": "campaign-021",
  "name": "Hidden Promenade",
  "seed": "campaign:21",
  "startDir": "W",
  "mowerRule": {
    "kind": "minTier",
    "tier": 0
  },
  "rows": [
    "......_.....",
    "....ww_.....",
    "....ww_.....",
    "....ww_.....",
    "......_.....",
    "......_....,",
    "*....._....,",
    "*....._s...,",
    "*....._s....",
    "......_.....",
    "..T.,T_.T..T",
    ".....,_.....",
    "....,._.....",
    "............",
    "..x........S"
  ],
  "critters": [
    {
      "kind": "squirrel",
      "x": 1,
      "y": 4
    },
    {
      "kind": "squirrel",
      "x": 2,
      "y": 13
    }
  ],
  "pickups": [
    {
      "kind": "gas",
      "x": 4,
      "y": 0
    },
    {
      "kind": "gas",
      "x": 5,
      "y": 8
    },
    {
      "kind": "coin",
      "x": 6,
      "y": 8
    },
    {
      "kind": "coin",
      "x": 6,
      "y": 9
    },
    {
      "kind": "coin",
      "x": 6,
      "y": 7
    },
    {
      "kind": "coin",
      "x": 10,
      "y": 12
    },
    {
      "kind": "coin",
      "x": 9,
      "y": 11
    },
    {
      "kind": "coin",
      "x": 11,
      "y": 3
    }
  ],
  "generatorVersion": 3,
  "level": 21,
  "biome": "park",
  "par": {
    "reel": 6216,
    "push": 5034,
    "selfPropelled": 4596,
    "tractor": 4350,
    "zeroTurn": 3175,
    "fairway": 2060
  },
  "routeTries": {
    "par": {
      "reel": 21,
      "push": 15,
      "selfPropelled": 6,
      "tractor": 0,
      "zeroTurn": 16,
      "fairway": 5
    }
  }
}
